import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="table-column-visibility"
export default class extends Controller {
  static targets = ['checkbox', 'column', 'status']
  static values = {
    refreshInterval: { type: Number, default: 10000 },
    storageKey: String,
    url: String
  }

  connect () {
    const storedVisibility = window.localStorage.getItem(this.storageKeyValue)
    const visible = storedVisibility === 'true'

    this.checkboxTarget.checked = visible
    this.setColumnVisibility(visible)
    if (visible) this.startPolling()
  }

  disconnect () {
    this.stopPolling()
  }

  toggle () {
    const visible = this.checkboxTarget.checked

    this.setColumnVisibility(visible)
    window.localStorage.setItem(this.storageKeyValue, visible.toString())
    visible ? this.startPolling() : this.stopPolling()
  }

  setColumnVisibility (visible) {
    this.columnTargets.forEach((column) => { column.hidden = !visible })
  }

  startPolling () {
    this.stopPolling()
    this.refreshStatuses()
    this.pollingInterval = window.setInterval(() => { this.refreshStatuses() }, this.refreshIntervalValue)
  }

  stopPolling () {
    if (this.pollingInterval === undefined) return

    window.clearInterval(this.pollingInterval)
    this.pollingInterval = undefined
  }

  async refreshStatuses () {
    const url = new URL(this.urlValue, window.location.origin)
    this.statusTargets.forEach((cell) => { url.searchParams.append('event_ids[]', cell.dataset.eventId) })

    try {
      const response = await fetch(url, { cache: 'no-store', headers: { Accept: 'application/json' } })
      if (!response.ok) return

      const statuses = await response.json()
      this.statusTargets.forEach((cell) => { cell.textContent = statuses[cell.dataset.eventId] ?? '-' })
    } catch (error) {
      console.error('Unable to refresh task statuses', error)
    }
  }
}
